require.register("registration/app", function(exports, require, module){
  $0
  
});

